import React from "react";
import { cn } from "@/utils/cn";

export type ExperienceCardProps = {
  image: string;
  title: string;
  description: string;
  className?: string;
};

export type ExperienceItem = {
  readonly image: string;
  readonly title: string;
  readonly description: string;
};

export const ExperienceCard: React.FC<ExperienceCardProps> = ({
  image,
  title,
  description,
  className,
}) => (
  <div
    className={cn("hw-card flex w-full flex-col gap-4 rounded-2xl bg-white p-6", className)}
  >
    <img
      src={image}
      alt=""
      loading="lazy"
      className="h-36 w-36 self-center object-contain"
    />
    <div className="flex flex-col gap-4">
      <h4 className="subtitle-b-bold text-black">{title}</h4>
      <p className="body-b-regular text-black">{description}</p>
    </div>
  </div>
);
